import "./Media.scss";
import InfoDialog from "@/components/Common/InfoDialog/InfoDialog.vue";
import POIImagePreview from "@/components/POI/POIImagePreview/POIImagePreview.vue";
import POIFilePreview from "@/components/POI/POIFilePreview/POIFilePreview.vue";
import POIStep from "@/components/POI/POIStep/POIStep.vue";
import _ from "lodash";
import { uploadFile } from "@/helpers/fileHelper";
import {
  getImageDimensionSizes,
  getMongoFileId,
  generateImageFromPdf
} from "@/helpers/commonHelper";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";

export default {
  name: "Media",
  components: {
    InfoDialog,
    POIImagePreview,
    POIFilePreview,
    POIStep
  },
  data: () => ({
    mainDialog: false,
    logoDialog: false,
    mainDragging: false,
    logoDragging: false,
    fileDragging: false,
    logoFile: "",
    webcamLinks: [{ title: "", link: "" }],
    /*******************************************************************
     *  Der Sinn hier ist, dass beim umsortieren
     *  der Watcher nicht ausgeführt wird und die Liste nicht neu gerendert wird.
     *  Bessere Lösungen gerne Willkommen :)
     *******************************************************************/
    preventMainWatch: false,
    preventLogoWatch: false,
    preventFileWatch: false
  }),
  props: ["editedItem", "step", "position", "isOwnedBySubPrincipal"],
  methods: {
    generateImageFromPdf,
    async addDropFile(e, type) {
      if (!this.editedItem?._id && !this.editedItem?.id) {
        await this.$store.dispatch("createError", {
          text: "Bitte zuerst speichern!"
        });
        return; // without specific id already set, we are creating a mess when multiple files are uploaded - we would create a poi for each file here
      }

      if (!Array.isArray(this[`${type}Files`])) this[`${type}Files`] = [];
      const files = e?.dataTransfer?.files ?? e ?? [];

      await Array.from(files).asyncForEach(async file => {
        const isPdfFile = file.type.toLowerCase() === "application/pdf";

        const data = await uploadFile(
          file,
          this.editedItem.id || this.editedItem._id,
          "pois",
          this.editedItem.principal,
          progressEvent => {
            this.$store.dispatch(
              "createSuccess",
              Math.round((progressEvent.loaded * 100) / progressEvent.total) +
                " % hochgeladen.."
            );
          }
        );

        if (type === "main" && !data.imageSizes && data.url) {
          data.imageSizes = await getImageDimensionSizes(data.url);
        } else if (type === "file" && isPdfFile) {
          const generatedPdfPicture = await this.generateImageFromPdf(
            data.url,
            data.title.replace(".pdf", "")
          );
          data.picture = await uploadFile(
            generatedPdfPicture,
            this.editedItem.id || this.editedItem._id,
            "pois",
            this.editedItem.principal,
            progressEvent => {
              this.$store.dispatch(
                "createSuccess",
                Math.round((progressEvent.loaded * 100) / progressEvent.total) +
                  " % Bild aus PDF generiert ..."
              );
            }
          );
        }
        if (!data.showIn) {
          data.showIn = "gallery";
        }
        if (type === "main") {
          data.fit_cover = true;
        }

        this[`${type}Files`].push(data);
        this.$emit("save", false);
      });
    },

    async changeStep(position) {
      // without category and title we can't save the poi, so we can't go into this step, we need an _id to upload files!
      if (
        (!this.editedItem?.title?.length ||
          !this.editedItem?.category?.length) &&
        !this.editedItem?._id
      ) {
        await this.$store.dispatch("createError", {
          text: "Bitte zuerst Pflichtfelder füllen & speichern!"
        });
        return;
      }

      // when we want to upload images, we already need a poi entry with _id
      if (!this.editedItem?._id && !this.editedItem?.id) {
        await this.$emit("save", false);
      }

      this.$emit("changeStep", position);
    },

    readFileUrl(file) {
      return new Promise((resolve, reject) => {
        if (file) {
          const reader = new FileReader();
          reader.onload = ({ target }) => {
            if (target?.result) resolve(target.result);
            else reject("Unable to read File");
          };
          reader.readAsDataURL(file);
        } else reject("No file passed");
      });
    },

    readFileUrls(files, type) {
      this[`${type}Dragging`] = false;
      this[`${type}Files`].forEach(file => {
        if (!file.id) {
          const reader = new FileReader();
          reader.onload = event => {
            const target = event.target;
            if (target?.result) {
              file.originalUrl = target.result;
              file.dataUrl = target.result;
            }
          };
          reader.readAsDataURL(file);
        }
      });
    },
    setMainFiles(newVal) {
      const order = newVal.map(v => v.id);
      this.preventMainWatch = true;
      this.mainFiles = _.sortBy(this.mainFiles, file => {
        return _.indexOf(order, file.id);
      });
    },
    async removeFile(id, type) {
      const isConfirmed = await this.$confirm(
        "Wollen Sie die Datei und das eventuell dazugehörige Bild wirklich löschen?",
        confirmWarningConfig
      );
      if (!isConfirmed) {
        return;
      }
      const index = this[`${type}Files`].findIndex(f => f.id === id);
      if (
        !this.$refs.poiImagePreview?.isImageFromExternalSource(
          this[`${type}Files`][index]
        )
      ) {
        this.$emit("addToDestroyList", id);
      }

      if (type === "file") {
        const picture = this[`${type}Files`].find(f => f.id === id)?.picture;
        if (picture?.id) {
          this.$emit("addToDestroyList", picture.id);
        }
      }

      this[`${type}Files`].splice(index, 1);
    },
    clear() {
      this.mainDialog = false;
      this.logoDialog = false;
      this.mainDragging = false;
      this.fileDragging = false;
      this.logoDragging = false;
      this.preventMainWatch = false;
      this.preventFileWatch = false;
      this.preventLogoWatch = false;

      this.mainFiles.splice(0, this.mainFiles.length);
      this.fileFiles.splice(0, this.fileFiles.length);
    },
    async setLogoFile(e) {
      const file = e?.dataTransfer?.files?.[0] ?? e;
      if (file) {
        this.logoFile = await this.readFileUrl(file);
        this.editedItem.logo = file;
      }
      this.logoDragging = false;
    },
    async confirmRemoveLogoFile() {
      const isConfirmed = await this.$confirm(
        "Sind Sie sicher, dass Sie das Logo löschen möchten?",
        confirmWarningConfig
      );
      if (isConfirmed) {
        await this.removeLogoFile();
      }
    },
    async removeLogoFile() {
      this.editedItem.logo = "";
      this.logoFile = "";
      if (
        !this.$refs.poiImagePreview.isImageFromExternalSource(
          this.editedItem.logo
        )
      ) {
        this.$emit(
          "addToDestroyList",
          getMongoFileId({ url: this.editedItem.logo })
        );
      }
    },
    addWebcam() {
      this.editedItem.webcamLinks.push({ title: "", link: "" });
    },
    removeWebcam(index) {
      this.editedItem.webcamLinks.splice(index, 1);
    },
    moveUp(array, element) {
      this.move(array, element, -1);
    },
    moveDown(array, element) {
      this.move(array, element, 1);
    },
    /**
     * move a element inside a array up or down
     * @param array
     * @param element
     * @param delta f.e. -1 to move up and 1 to move down
     */
    move(array, element, delta) {
      let index = array.indexOf(element); //find element to move
      let newIndex = index + delta; //calculate destination-index
      if (newIndex < 0 || newIndex === array.length) return; //Already at the top or bottom.
      let indexes = [index, newIndex].sort(); //Sort the indexes
      array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]); //Replace from lowest index, two elements, reverting the order
    }
  },
  watch: {
    mainFiles(val) {
      if (!this.preventMainWatch) {
        this.readFileUrls(val, "main");
      } else this.preventMainWatch = false;
    },
    fileFiles(val) {
      if (!this.preventFileWatch) {
        this.readFileUrls(val, "file");
      } else this.preventFileWatch = false;
    }
  },
  computed: {
    showLockCheckbox() {
      return this.$store.state.selectedPrincipal?.showLockCheckbox;
    },
    mainFiles: {
      get() {
        return this.editedItem?.pictures ?? [];
      },
      set(value) {
        this.editedItem.pictures = value;
      }
    },
    fileFiles: {
      get() {
        return this.editedItem?.files ?? [];
      },
      set(value) {
        this.editedItem.files = value;
      }
    },
    logoFileUrl() {
      return this.logoFile || this.editedItem.logo || "";
    }
  }
};
